export const assetsPath = "assets/";
var imgsPath = assetsPath + "img/";
export const audioPath = assetsPath + "audio/";

export const to_load = {
    'win_font_bg'				: imgsPath + 'fonts/win_font_bg_{q}.png',

    "background"				: imgsPath + "reels/reels_background_{q}.jpg",
    "mystery_background"		: imgsPath + "mystery/mystery_background_{q}.jpg",

    //"settings_curation"			: imgsPath + "wintable/wintable_curtain_{q}.png",
    "wintable_bg"				: imgsPath + "wintable/wintable_bg_{q}.jpg",
    "wintable_1"				: imgsPath + "wintable/wintable_1_{q}.png",
    "wintable_1_es"				: imgsPath + "wintable/wintable_1_es_{q}.png",
    "wintable_2"				: imgsPath + "wintable/wintable_2_{q}.png",

    "big_win"					: imgsPath + "bigwin/big_win_{q}.png",
    "mega_win"					: imgsPath + "bigwin/mega_win_{q}.png",
    "super_mega_win"			: imgsPath + "bigwin/super_mega_win_{q}.png",
    "free_spins"				: imgsPath + "bigwin/free_spins_{q}.png",
    "big_win_rope"				: imgsPath + "bigwin/big_win_rope_{q}.png",
};

export const to_load_json_atlas = {
    'reels_atlas': [imgsPath + "reels/reels_atlas_{q}.png", imgsPath + "reels/reels_atlas_{q}.json"],
    'mystery_atlas': [imgsPath + "mystery/mystery_atlas_{q}.png", imgsPath + "mystery/mystery_atlas_{q}.json"],

    'symbols_atlas': [imgsPath + "symbols/symbols_all_atlas_{q}.png", imgsPath + "symbols/symbols_all_atlas_{q}.json"],

    'symbol_Devil_touchdown_json': [
        imgsPath + "symbols/symbol_Devil/symbol_Devil_td_atlas_{q}.png",
        imgsPath + "symbols/symbol_Devil/symbol_Devil_td_atlas_{q}.json"
    ],
    'symbol_King_touchdown_json': [
        imgsPath + "symbols/symbol_King/symbol_King_td_atlas_{q}.png",
        imgsPath + "symbols/symbol_King/symbol_King_td_atlas_{q}.json"
    ],
    'symbol_Knight_touchdown_json': [
        imgsPath + "symbols/symbol_Knight/symbol_Knight_td_atlas_{q}.png",
        imgsPath + "symbols/symbol_Knight/symbol_Knight_td_atlas_{q}.json"
    ],
    'symbol_Mystery_touchdown_json': [
        imgsPath + "symbols/symbol_Mystery/symbol_Witch_td_atlas_{q}.png",
        imgsPath + "symbols/symbol_Mystery/symbol_Witch_td_atlas_{q}.json"
    ],
    'symbol_Nix_touchdown_json': [
        imgsPath + "symbols/symbol_Nix/symbol_Nix_td_atlas_{q}.png",
        imgsPath + "symbols/symbol_Nix/symbol_Nix_td_atlas_{q}.json"
    ],
    'symbol_Princess_touchdown_json': [
        imgsPath + "symbols/symbol_Princess/symbol_Princess_td_atlas_{q}.png",
        imgsPath + "symbols/symbol_Princess/symbol_Princess_td_atlas_{q}.json"
    ],
    'symbol_Queen_touchdown_json': [
        imgsPath + "symbols/symbol_Queen/symbol_Queen_td_atlas_{q}.png",
        imgsPath + "symbols/symbol_Queen/symbol_Queen_td_atlas_{q}.json"
    ],
    'symbol_Scatter_touchdown_json': [
        imgsPath + "symbols/symbol_Scatter/symbol_Clown_td_atlas_{q}.png",
        imgsPath + "symbols/symbol_Scatter/symbol_Clown_td_atlas_{q}.json"
    ],
    'symbol_Wild_touchdown_json': [
        imgsPath + "symbols/symbol_Wild/symbol_Wild_td_atlas_{q}.png",
        imgsPath + "symbols/symbol_Wild/symbol_Wild_td_atlas_{q}.json"
    ],

    'symbol_Wild_sheet_json': [imgsPath + "symbols/symbol_Wild/symbol_Wild_win_atlas_{q}.png", imgsPath + "symbols/symbol_Wild/symbol_Wild_win_atlas_{q}.json"],
    'symbol_Scatter_sheet_json': [imgsPath + "symbols/symbol_Scatter/symbol_Clown_win_atlas_{q}.png", imgsPath + "symbols/symbol_Scatter/symbol_Clown_win_atlas_{q}.json"],
    'symbol_Queen_sheet_json': [imgsPath + "symbols/symbol_Queen/symbol_Queen_win_atlas_{q}.png", imgsPath + "symbols/symbol_Queen/symbol_Queen_win_atlas_{q}.json"],
    'symbol_Princess_sheet_json': [imgsPath + "symbols/symbol_Princess/symbol_Princess_win_atlas_{q}.png", imgsPath + "symbols/symbol_Princess/symbol_Princess_win_atlas_{q}.json"],
    'symbol_Nix_sheet_json': [imgsPath + "symbols/symbol_Nix/symbol_Nix_win_atlas_{q}.png", imgsPath + "symbols/symbol_Nix/symbol_Nix_win_atlas_{q}.json"],
    'symbol_Mystery_sheet_json': [imgsPath + "symbols/symbol_Mystery/symbol_Witch_win_atlas_{q}.png", imgsPath + "symbols/symbol_Mystery/symbol_Witch_win_atlas_{q}.json"],
    'symbol_Knight_sheet_json': [imgsPath + "symbols/symbol_Knight/symbol_Knight_win_atlas_{q}.png", imgsPath + "symbols/symbol_Knight/symbol_Knight_win_atlas_{q}.json"],
    'symbol_King_sheet_json': [imgsPath + "symbols/symbol_King/symbol_King_win_atlas_{q}.png", imgsPath + "symbols/symbol_King/symbol_King_win_atlas_{q}.json"],
    'symbol_Devil_sheet_json': [imgsPath + "symbols/symbol_Devil/symbol_Devil_win_atlas_{q}.png", imgsPath + "symbols/symbol_Devil/symbol_Devil_win_atlas_{q}.json"],


    'symbol_Wild_to_symbol_Devil_json': [
        imgsPath + "symbols/symbol_Wild/symbol_Wild_to_Devil_atlas_{q}.png", imgsPath + "symbols/symbol_Wild/symbol_Wild_to_Devil_atlas_{q}.json"
    ],
    'symbol_Wild_to_symbol_King_json': [
        imgsPath + "symbols/symbol_Wild/symbol_Wild_to_King_atlas_{q}.png", imgsPath + "symbols/symbol_Wild/symbol_Wild_to_King_atlas_{q}.json"
    ],
    'symbol_Wild_to_symbol_Knight_json': [
        imgsPath + "symbols/symbol_Wild/symbol_Wild_to_Knight_atlas_{q}.png", imgsPath + "symbols/symbol_Wild/symbol_Wild_to_Knight_atlas_{q}.json"
    ],
    'symbol_Wild_to_symbol_Nix_json': [
        imgsPath + "symbols/symbol_Wild/symbol_Wild_to_Nix_atlas_{q}.png", imgsPath + "symbols/symbol_Wild/symbol_Wild_to_Nix_atlas_{q}.json"
    ],
    'symbol_Wild_to_symbol_Princess_json': [
        imgsPath + "symbols/symbol_Wild/symbol_Wild_to_Princess_atlas_{q}.png", imgsPath + "symbols/symbol_Wild/symbol_Wild_to_Princess_atlas_{q}.json"
    ],
    'symbol_Wild_to_symbol_Queen_json': [
        imgsPath + "symbols/symbol_Wild/symbol_Wild_to_Queen_atlas_{q}.png", imgsPath + "symbols/symbol_Wild/symbol_Wild_to_Queen_atlas_{q}.json"
    ]
};

export const to_load_audio = {

    "fs_counter"			: audioPath + "bonus_FreeSpins_Counter.ogg",

    "BACKGROUND"			: audioPath + "bg_Music.ogg",
    //"BACKGROUND_FS"		: audioPath + "bg_FreeSpins.ogg",
    //"mystery_background"	: audioPath + "bg_Mystery.ogg",

    "mystery_btn"			: audioPath + "bonus_Mystery_Button.ogg",
    "mystery_count"			: audioPath + "bonus_Mystery_Counter.ogg",
    "mystery_win"			: audioPath + "bonus_Mystery_Counter_Stop.ogg",
    "mystery_witch"			: audioPath + "bonus_Mystery_Rope.ogg",

    "big_win_snd"			: audioPath + "bwin_BigWin.ogg",
    "mega_win_snd"			: audioPath + "bwin_MegaWin.ogg",
    "super_mega_win_snd"	: audioPath + "bwin_SuperMegaWin.ogg",

    "loop_win_celebrate"	: audioPath + "win_Normal.ogg",

    "fly_1"					: audioPath + "misc_Tetris_1.ogg",
    "fly_2"					: audioPath + "misc_Tetris_2.ogg",
    "fly_3"					: audioPath + "misc_Tetris_3.ogg",
    "fly_4"					: audioPath + "misc_Tetris_4.ogg",
    "fly_5"					: audioPath + "misc_Tetris_5.ogg",

    "REEL_BG"				: audioPath + "reel_Spin.ogg",
    "REEL_TEAS"				: audioPath + "reel_Search.ogg",

    "pre_reels"				: audioPath + "reel_Start.ogg",

    "reel_stop_1"			: audioPath + "reel_Stop_1.ogg",
    "reel_stop_2"			: audioPath + "reel_Stop_2.ogg",
    "reel_stop_3"			: audioPath + "reel_Stop_3.ogg",
    "reel_stop_4"			: audioPath + "reel_Stop_4.ogg",
    "reel_stop_5"			: audioPath + "reel_Stop_5.ogg",

    "reel_tetris_stop_1"	: audioPath + "reel_Tetris_1.ogg",
    "reel_tetris_stop_2"	: audioPath + "reel_Tetris_2.ogg",
    "reel_tetris_stop_3"	: audioPath + "reel_Tetris_3.ogg",
    "reel_tetris_stop_4"	: audioPath + "reel_Tetris_4.ogg",
    "reel_tetris_stop_5"	: audioPath + "reel_Tetris_5.ogg",

    "bonus_snd_1"			: audioPath + "symbol_Bonus_1.ogg",
    "bonus_snd_2"			: audioPath + "symbol_Bonus_2.ogg",
    "bonus_snd_3"			: audioPath + "symbol_Bonus_3.ogg",
    "bonus_snd_4"			: audioPath + "symbol_Bonus_4.ogg",
    "bonus_snd_5"			: audioPath + "symbol_Bonus_5.ogg",

    "mystery_snd_1"			: audioPath + "symbol_Mystery_1.ogg",
    "mystery_snd_2"			: audioPath + "symbol_Mystery_2.ogg",
    "mystery_snd_3"			: audioPath + "symbol_Mystery_3.ogg",
    "mystery_snd_4"			: audioPath + "symbol_Mystery_4.ogg",
    "mystery_snd_5"			: audioPath + "symbol_Mystery_5.ogg",

    "wild_snd_1"			: audioPath + "symbol_Wild_1.ogg",
    "wild_snd_2"			: audioPath + "symbol_Wild_2.ogg",
    "wild_snd_3"			: audioPath + "symbol_Wild_3.ogg",
    "wild_snd_4"			: audioPath + "symbol_Wild_4.ogg",
    "wild_snd_5"			: audioPath + "symbol_Wild_5.ogg",

    "win_symbol_Scatter_3"	: audioPath + "win_Clown_3x.ogg",
    "win_symbol_Devil_3"	: audioPath + "win_Devil_3x.ogg",
    "win_symbol_Knight_3"	: audioPath + "win_Knight_3x.ogg",
    "win_symbol_King_3"		: audioPath + "win_King_3x.ogg",
    "win_symbol_Nix_3"		: audioPath + "win_Nix_3x.ogg",
    "win_symbol_Princess_3"	: audioPath + "win_Princess_3x.ogg",
    "win_symbol_Queen_3"	: audioPath + "win_Queen_3x.ogg",
    "win_symbol_Mystery_3"	: audioPath + "win_Witch_3x.ogg",
    "win_symbol_Wild_3"		: audioPath + "win_Wild_3x.ogg",

    "misc_Rope_Left"		: audioPath + "misc_Rope_Left.ogg",
    "misc_Rope_Right"		: audioPath + "misc_Rope_Right.ogg",
	Jackpot_sound: assetsPath + "JokerWinBanner/Jackpot_sound.mp3",
	JokerBonus_alert: assetsPath + "JokerWinBanner/JokerBonus_alert.mp3",	
};

export const to_load_json = {
    'infotext' 				: assetsPath + "info/info_{l}.json"
};

export const to_load_fonts = {
    'win_font' :	{
        "img":	imgsPath + 'fonts/win_font.png',
        "xml":	imgsPath + 'fonts/win_font.xml'
    },

    'font_winplane': {
        'img': imgsPath + 'fonts/font_winplane.png',
        'xml': imgsPath + 'fonts/font_winplane.xml',
    },
    'font_bigwin': {
        'img': imgsPath + 'fonts/font_big_win.png',
        'xml': imgsPath + 'fonts/font_big_win.xml',
    },
    /*'font_win_count' :	{
            'img':	imgsPath + 'fonts/win_count.png',
            'xml':	imgsPath + 'fonts/win_count.xml',
    },*/
    'font_freespin': {
        'img': imgsPath + 'fonts/font_free_spins.png',
        'xml': imgsPath + 'fonts/font_free_spins.xml',
    }
};

export const post_load_audio_win_symbols = {
    "win_symbol_Scatter_4"	: audioPath + "win_Clown_4x.ogg",
    "win_symbol_Scatter_5"	: audioPath + "win_Clown_5x.ogg",
    "win_symbol_Devil_4"	: audioPath + "win_Devil_4x.ogg",
    "win_symbol_Devil_5"	: audioPath + "win_Devil_5x.ogg",
    "win_symbol_Knight_4"	: audioPath + "win_Knight_4x.ogg",
    "win_symbol_Knight_5"	: audioPath + "win_Knight_5x.ogg",
    "win_symbol_King_4"		: audioPath + "win_King_4x.ogg",
    "win_symbol_King_5"		: audioPath + "win_King_5x.ogg",
    "win_symbol_Nix_4"		: audioPath + "win_Nix_4x.ogg",
    "win_symbol_Nix_5"		: audioPath + "win_Nix_5x.ogg",
    "win_symbol_Princess_4"	: audioPath + "win_Princess_4x.ogg",
    "win_symbol_Princess_5"	: audioPath + "win_Princess_5x.ogg",
    "win_symbol_Queen_4"	: audioPath + "win_Queen_4x.ogg",
    "win_symbol_Queen_5"	: audioPath + "win_Queen_5x.ogg",
    "win_symbol_Mystery_4"	: audioPath + "win_Witch_4x.ogg",
    "win_symbol_Mystery_5"	: audioPath + "win_Witch_5x.ogg",
    "win_symbol_Wild_4"		: audioPath + "win_Wild_4x.ogg",
    "win_symbol_Wild_5"		: audioPath + "win_Wild_5x.ogg",
};

export const post_load_json_atlas_standing = {
    'symbol_Devil_standing_json': [imgsPath + "symbols/symbol_Devil/symbol_Devil_stand_atlas_{q}.png", imgsPath + "symbols/symbol_Devil/symbol_Devil_stand_atlas_{q}.json"],
    'symbol_King_standing_json': [imgsPath + "symbols/symbol_King/symbol_King_stand_atlas_{q}.png", imgsPath + "symbols/symbol_King/symbol_King_stand_atlas_{q}.json"],
    'symbol_Knight_standing_json': [imgsPath + "symbols/symbol_Knight/symbol_Knight_stand_atlas_{q}.png", imgsPath + "symbols/symbol_Knight/symbol_Knight_stand_atlas_{q}.json"],
    'symbol_Mystery_standing_json': [imgsPath + "symbols/symbol_Mystery/symbol_Witch_stand_atlas_{q}.png", imgsPath + "symbols/symbol_Mystery/symbol_Witch_stand_atlas_{q}.json"],
    'symbol_Nix_standing_json': [imgsPath + "symbols/symbol_Nix/symbol_Nix_stand_atlas_{q}.png", imgsPath + "symbols/symbol_Nix/symbol_Nix_stand_atlas_{q}.json"],
    'symbol_Princess_standing_json': [imgsPath + "symbols/symbol_Princess/symbol_Princess_stand_atlas_{q}.png", imgsPath + "symbols/symbol_Princess/symbol_Princess_stand_atlas_{q}.json"],
    'symbol_Queen_standing_json': [imgsPath + "symbols/symbol_Queen/symbol_Queen_stand_atlas_{q}.png", imgsPath + "symbols/symbol_Queen/symbol_Queen_stand_atlas_{q}.json"],
    'symbol_Scatter_standing_json': [imgsPath + "symbols/symbol_Scatter/symbol_Clown_stand_atlas_{q}.png", imgsPath + "symbols/symbol_Scatter/symbol_Clown_stand_atlas_{q}.json"],
    'symbol_Wild_standing_json': [imgsPath + "symbols/symbol_Wild/symbol_Wild_stand_atlas_{q}.png", imgsPath + "symbols/symbol_Wild/symbol_Wild_stand_atlas_{q}.json"]
};

import { madnes_set_audio_volume } from "../../framework/src/engine/madnes/madnes_audio";

export function set_sounds(server_config)
{
    var vol = 1;

    if(typeof server_config['volume']['bigWin'] != "undefined") {
        vol = server_config['volume']['bigWin'];

        madnes_set_audio_volume('big_win_snd', vol);
        madnes_set_audio_volume('mega_win_snd', vol);
        madnes_set_audio_volume('super_mega_win_snd', vol);
    }

    if(typeof server_config["volume"]["buttonEffect"] !== "undefined")
    {
        vol = server_config["volume"]["buttonEffect"];

        madnes_set_audio_volume('button_click', vol);
    }

    if(typeof server_config["volume"]["spin"] !== "undefined")
    {
        vol = server_config["volume"]["spin"];

        madnes_set_audio_volume('REEL_BG', vol);
    }

    if(typeof server_config["volume"]["startReel"] !== "undefined")
    {
        vol = server_config["volume"]["startReel"];

        madnes_set_audio_volume('pre_reels', vol);
    }

    if(typeof server_config["volume"]["stopReel"] !== "undefined") {
        vol = server_config["volume"]["stopReel"];

        madnes_set_audio_volume('reel_stop_1', vol);
        madnes_set_audio_volume('reel_stop_2', vol);
        madnes_set_audio_volume('reel_stop_3', vol);
        madnes_set_audio_volume('reel_stop_4', vol);
        madnes_set_audio_volume('reel_stop_5', vol);

        madnes_set_audio_volume('reel_tetris_stop_1', vol);
        madnes_set_audio_volume('reel_tetris_stop_2', vol);
        madnes_set_audio_volume('reel_tetris_stop_3', vol);
        madnes_set_audio_volume('reel_tetris_stop_4', vol);
        madnes_set_audio_volume('reel_tetris_stop_5', vol);
    }

    if(typeof server_config["volume"]["winAnim"] != "undefined") {
        vol = server_config["volume"]["winAnim"];

        madnes_set_audio_volume('win_symbol_Devil_3', vol);
        madnes_set_audio_volume('win_symbol_Devil_4', vol);
        madnes_set_audio_volume('win_symbol_Devil_5', vol);

        madnes_set_audio_volume('win_symbol_King_3', vol);
        madnes_set_audio_volume('win_symbol_King_4', vol);
        madnes_set_audio_volume('win_symbol_King_5', vol);

        madnes_set_audio_volume('win_symbol_Knight_3', vol);
        madnes_set_audio_volume('win_symbol_Knight_4', vol);
        madnes_set_audio_volume('win_symbol_Knight_5', vol);

        madnes_set_audio_volume('win_symbol_Mystery_3', vol);
        madnes_set_audio_volume('win_symbol_Mystery_4', vol);
        madnes_set_audio_volume('win_symbol_Mystery_5', vol);

        madnes_set_audio_volume('win_symbol_Nix_3', vol);
        madnes_set_audio_volume('win_symbol_Nix_4', vol);
        madnes_set_audio_volume('win_symbol_Nix_5', vol);

        madnes_set_audio_volume('win_symbol_Princess_3', vol);
        madnes_set_audio_volume('win_symbol_Princess_4', vol);
        madnes_set_audio_volume('win_symbol_Princess_5', vol);

        madnes_set_audio_volume('win_symbol_Queen_3', vol);
        madnes_set_audio_volume('win_symbol_Queen_4', vol);
        madnes_set_audio_volume('win_symbol_Queen_5', vol);

        madnes_set_audio_volume('win_symbol_Scatter_3', vol);
        madnes_set_audio_volume('win_symbol_Scatter_4', vol);
        madnes_set_audio_volume('win_symbol_Scatter_5', vol);

        madnes_set_audio_volume('win_symbol_Wild_3', vol);
        madnes_set_audio_volume('win_symbol_Wild_4', vol);
        madnes_set_audio_volume('win_symbol_Wild_5', vol);

        madnes_set_audio_volume('loop_win_celebrate', vol);
    }

    if(typeof server_config["volume"]["winCounter"] != "undefined")
    {
        vol = server_config["volume"]["winCounter"];

        madnes_set_audio_volume('remittance_A', vol);
        madnes_set_audio_volume('remittance_B', vol);
        madnes_set_audio_volume('fs_counter', vol);
    }

    if(typeof server_config["background"]["background"] != "undefined") {
        vol = server_config["background"]["background"];
        madnes_set_audio_volume('BACKGROUND', vol);
    }

    if(typeof server_config["background"]["freeSpinsBackground"] != "undefined") {
        vol = server_config["background"]["freeSpinsBackground"];

        madnes_set_audio_volume('BACKGROUND_FS', vol);
    }

    if(typeof server_config["background"]["bonusGameBackground"] != "undefined") {
        vol = server_config["background"]["bonusGameBackground"];

        madnes_set_audio_volume('mystery_background', vol);
    }

    if(typeof server_config["miscSounds"]["miscSounds1"] !== "undefined")
    {
        vol = server_config["miscSounds"]["miscSounds1"];

        madnes_set_audio_volume('coins_loop', vol);
    }

    if(typeof server_config["miscSounds"]["miscSounds2"] !== "undefined")
    {
        vol = server_config["miscSounds"]["miscSounds2"];

        madnes_set_audio_volume('wild_snd_1', vol);
        madnes_set_audio_volume('wild_snd_2', vol);
        madnes_set_audio_volume('wild_snd_3', vol);
        madnes_set_audio_volume('wild_snd_4', vol);
        madnes_set_audio_volume('wild_snd_5', vol);

        madnes_set_audio_volume('bonus_snd_1', vol);
        madnes_set_audio_volume('bonus_snd_2', vol);
        madnes_set_audio_volume('bonus_snd_3', vol);
        madnes_set_audio_volume('bonus_snd_4', vol);
        madnes_set_audio_volume('bonus_snd_5', vol);

        madnes_set_audio_volume('mystery_snd_1', vol);
        madnes_set_audio_volume('mystery_snd_2', vol);
        madnes_set_audio_volume('mystery_snd_3', vol);
        madnes_set_audio_volume('mystery_snd_4', vol);
        madnes_set_audio_volume('mystery_snd_5', vol);

        madnes_set_audio_volume('mystery_btn', vol);
    }

    if(typeof server_config["miscSounds"]["miscSounds3"] !== "undefined")
    {
        vol = server_config["miscSounds"]["miscSounds3"];

        madnes_set_audio_volume('REEL_TEAS', vol);
        madnes_set_audio_volume('fly_1', vol);
        madnes_set_audio_volume('fly_2', vol);
        madnes_set_audio_volume('fly_3', vol);
        madnes_set_audio_volume('fly_4', vol);
        madnes_set_audio_volume('fly_5', vol);
    }

    if(typeof server_config["miscSounds"]["miscSounds4"] !== "undefined")
    {
        vol = server_config["miscSounds"]["miscSounds4"];

        madnes_set_audio_volume('misc_Rope_Left', vol);
        madnes_set_audio_volume('misc_Rope_Right', vol);
    }

    if(typeof server_config["miscSounds"]["miscSounds5"] !== "undefined")
    {
        vol = server_config["miscSounds"]["miscSounds5"];

        madnes_set_audio_volume('mystery_count', vol);
        madnes_set_audio_volume('mystery_win', vol);
        madnes_set_audio_volume('mystery_witch', vol);
    }
}